import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const usePolicyEnabled = () => {
    const { isPageBlocked } = usePricingModulesState();
    const isPolicyEnabled = !isPageBlocked(LAYOUT_TABS.POLICY.ID);

    return isPolicyEnabled;
};
